import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTypes,
  fetchTypeById,
  updateType,
  updateStatusInType,
  addType,
} from "./thunk";

interface TypeState {
  typeList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedType: any;
}

const initialState: TypeState = {
  typeList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedType: null,
};

const typeSlice = createSlice({
  name: "type",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.typeList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Types";
      })
      .addCase(fetchTypeById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedType = action.payload;
      })
      .addCase(fetchTypeById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateType.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.typeList = state.typeList.map((type) =>
          type.id === action.payload.id ? action.payload : type
        );
      })
      .addCase(updateType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Type";
      })
      .addCase(updateStatusInType.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.typeList = state.typeList.map((type) =>
        //   type.id === action.payload.id ? action.payload : type
        // );
      })
      .addCase(updateStatusInType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default typeSlice.reducer;
